import { makeStyles } from '@material-ui/core';
import { PORTAL_BRAND_TOKENS } from '../../theme/portalTheme';
import { HIPER_SAUDE_LOGO } from './logoAsset';

const useStyles = makeStyles({
  // Chip branco arredondado: o logo tem fundo branco e a navegação é escura,
  // então o chip deixa a marca legível e intencional em vez de um retângulo solto.
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PORTAL_BRAND_TOKENS.color.surface,
    borderRadius: PORTAL_BRAND_TOKENS.shape.borderRadius,
    padding: 6,
  },
  img: {
    display: 'block',
    height: 40,
    width: 'auto',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <span className={classes.chip}>
      <img
        className={classes.img}
        src={HIPER_SAUDE_LOGO}
        alt="Grupo Hiper Saúde"
      />
    </span>
  );
};
